import { RadioGroup } from "@mui/material";
import { t } from "i18next";
import CustomRadio from "../../Components/custom-radio/CustomRadio";
import { useEffect, useState } from "react";
import { CustomTextField } from "../../Components/custom-textfield/CustomTextField";
import Calendar from "../../Components/custom-calendar/Calendar";
import * as ClaimService from "../../Services/claim-service";
import { format } from 'date-fns';
import { CustomHelpText } from "../../Components/custom-help-text/CustomHelpText";
import * as Service from "../../Services/service";

function ClaimRequestOther({ objectDto, setObjectDto, setLoading }) {
    const [check, setCheck] = useState(false);
    const [yesChecked, setYesChecked] = useState(objectDto.yesChecked !== undefined && objectDto.yesChecked !== "" ?
        objectDto.yesChecked === 0 ? false : true : false);
    useEffect(() => {
        if (objectDto.yesChecked !== undefined && objectDto.yesChecked !== "") {
            setYesChecked(objectDto.yesChecked === 0 ? false : true);
        }
    }, [objectDto]);

    function onValueRadioChange(event) {
        if (event.target.value === "1") {
            setObjectDto({ ...objectDto, yesChecked: 1 });
            setYesChecked(true);
        } else if (event.target.value === "0") {
            setObjectDto({ ...objectDto, yesChecked: 0, sumAssured: null, effectiveDate: null, companyName: null });
            setCheck(false);
            setYesChecked(false);
            document.getElementById("addCompanyDiv").style.display = "none"
            document.getElementById("btCompanyAdd").style.display = "block"
        }
    }
    return (
        <div style={{ display: objectDto.checked > 4 ? "block" : "none" }}>
            <div data-toggle="collapse" data-target="#search-box-5" className="header-box" id="search-box-5-header">
                <h2 className="title-box description-large-customer">{t("claimother").toUpperCase()}</h2>
            </div>
            <div className={"collapse in"} id="search-box-5">
                <div className="border-box-sc row">
                    <RadioGroup value={yesChecked ? 1 : 0} row={true} onChange={onValueRadioChange} className="col-md-12">
                        <label className="col-md-5 col-lg-5 col-xl-5 col-xs-12 col-sm-12 label-header description-medium-customer">
                            {t("claiminsuredother")}
                        </label>
                        <div className="col-md-2 col-lg-2 col-xl-2 col-xs-6 col-sm-6" style={{ bottom: "10px" }}>
                            <CustomRadio disabled={objectDto.checked > 5} title={t("yes")} value={1} id="yes" className="iCheck-radio" />
                        </div>
                        <div className="col-md-2 col-lg-2 col-xl-6 col-xs-6 col-sm-6" style={{ bottom: "10px" }}>
                            <CustomRadio disabled={objectDto.checked > 5} title={t("no")} value={0} id="yes" className="iCheck-radio" />
                        </div>
                    </RadioGroup>
                    <div id="otherDiv" style={{ display: objectDto.yesChecked === 1 ? "block" : "none" }} className="col-md-12">
                        <div id="addCompanyDiv" style={{ display: "none" }} hidden={!(objectDto.checked === 5)}>
                            <div className="col-md-12">
                                <label className="col-md-2 required description-small-customer" >{t("claimcompanyname")}</label>
                                <div className="col-md-10" style={{ marginBottom: "10px" }}>
                                    <CustomTextField variant="outlined" label={""} size="small" required fullWidth
                                        focusColor="#c4960c" value={objectDto.companyName || ""}
                                        helperText={(check === true && (objectDto.companyName === '' || objectDto.companyName === null)) ? t("NotEmptyjavalangString") : ""}
                                        onChange={(e) => { setObjectDto({ ...objectDto, companyName: e.target.value }) }}
                                    />
                                </div>
                                <label className="col-md-2 required description-small-customer">{t("policyeffecteddate")}</label>
                                <div className="col-md-4" style={{ marginBottom: "10px" }}>
                                    <Calendar title={""} value={objectDto.effectiveDate || null} handleChange={(value) => {
                                        setObjectDto({ ...objectDto, effectiveDate: value });
                                    }} />
                                    <CustomHelpText exist={objectDto.effectiveDate} hidden={ClaimService.validateValue(objectDto.effectiveDate) === false && check === true} />
                                </div>
                                <label className="col-md-2 required description-small-customer">{t("productsumassured")}</label>
                                <div className="col-md-4">
                                    <CustomTextField variant="outlined" label={""} size="small" required fullWidth
                                        focusColor="#c4960c" value={objectDto.sumAssured || ""}
                                        helperText={(check === true && (objectDto.sumAssured === '' || objectDto.sumAssured === null)) ? t("NotEmptyjavalangString") : ""}
                                        onChange={(e) => {
                                            setObjectDto({ ...objectDto, sumAssured: Service.numberOnly(e.target.value) })
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="footer-box-bg col-md-12">
                                <a id="cancelCompany" className="btn-common description-small-customer"
                                    onClick={() => {
                                        setCheck(false);
                                        document.getElementById("addCompanyDiv").style.display = "none"
                                        document.getElementById("btCompanyAdd").style.display = "block"
                                        setObjectDto({ ...objectDto, sumAssured: null, effectiveDate: null, companyName: null })
                                    }}>
                                    <i className="fa fa-ban" aria-hidden="true" />{" "}
                                    <span>{t("cancel")}</span>
                                </a>
                                <a id="btAddCompany" className="btn-common btn-search description-small-customer" onClick={() => {
                                    if (!(ClaimService.validateValue(objectDto.sumAssured) && ClaimService.validateValue(objectDto.effectiveDate)
                                        && ClaimService.validateValue(objectDto.companyName))) {
                                        setCheck(true);
                                    } else {
                                        ClaimService.HandleAddCompany(objectDto, setObjectDto, setLoading);
                                        document.getElementById("btCompanyAdd").style.display = "block";
                                        document.getElementById("addCompanyDiv").style.display = "none";
                                        setCheck(false);
                                    }
                                }}>
                                    <i className="fa fa-plus" aria-hidden="true" />{" "}
                                    <span>{t("save")}</span>
                                </a>
                            </div>
                        </div>
                        <div className="col-sm-12" id="companyAdd" hidden={!(objectDto.checked === 5)}>
                            <div className="icon-head d-flex" style={{ textAlign: "left", float: "left" }}>
                                <a id="btCompanyAdd" className="fa fa-plus-circle icon-head-red description-medium-customer" type="button" title={t("claimotheradd")}
                                    onClick={() => {
                                        document.getElementById("btCompanyAdd").style.display = "none"
                                        document.getElementById("addCompanyDiv").style.display = "block"
                                        setObjectDto({ ...objectDto, sumAssured: null, effectiveDate: null, companyName: null })
                                    }}
                                >
                                    <span className="description-medium-customer">{" " + t("claimotheradd")}</span>
                                </a>
                            </div>
                        </div>
                        <div id="otherTableDiv">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped " id="otherTable">
                                        <thead>
                                            <tr className="text-center">
                                                <th className="u_t_code th-phl description-small-customer">{t("actionlabel")}</th>
                                                <th className="u_t_no th-phl description-small-customer">#</th>
                                                <th className="u_t_title th-phl description-small-customer" >{t("claimcompanyname")}</th>
                                                <th className="u_t_date th-phl description-small-customer">{t("policyeffecteddate")}</th>
                                                <th className="u_t_code th-phl description-small-customer">{t("productsumassured")}</th>
                                            </tr>
                                        </thead>
                                        <tbody id="otherDetails">
                                            {objectDto.otherList !== undefined && objectDto.otherList.length !== 0 ?
                                                objectDto.otherList.map((item) => {
                                                    return <tr>
                                                        <td className="text-center">
                                                            <i className="fa fa-trash custom-icon delete btnDel" title={t("icondelete")}
                                                                onClick={() => {
                                                                    objectDto.checked === 5 ? ClaimService.RemoveCompany(objectDto, setObjectDto, item + 1) : {}
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="text-center description-small-customer">
                                                            {objectDto.otherList.indexOf(item) + 1}
                                                        </td>
                                                        <td className="text-left description-small-customer">
                                                            {item.companyName}
                                                        </td>
                                                        <td className="text-center description-small-customer">
                                                            {format(new Date(item.effectiveDate), 'dd / MM / yyyy')}
                                                        </td>
                                                        <td className="text-right description-small-customer">{ClaimService.currencyFormat(item.sumAssured)}</td>
                                                    </tr>
                                                }) : ""}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ClaimRequestOther;